import React from 'react';

interface ErrorStateProps {
  error: string;
}

export function ErrorState({ error }: ErrorStateProps) {
  return (
    <div className="p-4">
      <div className="text-sm text-red-600 bg-red-50 p-3 rounded-md">
        {error}
      </div>
    </div>
  );
}